import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import useCreateUser from 'sdk/hooks/user/useCreateUser';
import { validatePassword } from 'sdk/utils/validation';
import Button from 'components/shared/Button';
import Info from 'components/shared/Info';
import { PassInput } from 'components/shared/Input';
import { StringConstant } from 'utils/Constants';
import SignInLink from './SignInLink';
import styles from './SignUp.module.scss';

type PassViewProps = {
  handleNext: () => void,
  goToSignIn: () => void,
  email: string,
  className?: string,
}

const defaultErrMessage = 'Check the correctness of your password'

function PassView({
  handleNext,
  goToSignIn,
  email,
  className,
}: PassViewProps) {
  const [pass, setPass] = useState('')
  const [pass2, setPass2] = useState('')
  const [isPassVisible, setIsPassVisisble] = useState(false)
  const [showPassError, setShowPassError] = useState(false)
  const [passError, setPassError] = useState('')
  const {
    mutate: signUpMutation,
    error: signUpError,
    isSuccess: isSignUpSuccess,
    isError: isSignUpError,
    isLoading: isSignupLoading,
  } = useCreateUser({
    password: pass,
    email,
  })

  const handlePasswordChange = (e: React.FormEvent<HTMLInputElement>) => {
    setPass((e.target as HTMLInputElement).value.trim())
    setShowPassError(false)
    setPassError('')
  }

  const handlePassword2Change = (e: React.FormEvent<HTMLInputElement>) => {
    setPass2((e.target as HTMLInputElement).value.trim())
    setShowPassError(false)
    setPassError('')
  }

  useEffect(() => {
    if (isSignUpError) {
      setPassError(StringConstant.SIGN_UP_PASSWORD_ERROR)
      setShowPassError(true)
    }
  }, [isSignUpError])

  useEffect(() => {
    if (isSignUpSuccess) handleNext()
  }, [isSignUpSuccess])

  const isPassValid = validatePassword(pass) && (pass === pass2)

  const onBlurPass = () => setShowPassError(!isPassValid)
  const getError = () => {
    if (pass.length < 8) return 'The password is too short'
    if (pass !== pass2) return 'Passwords should match'
    return (passError || defaultErrMessage)
  }

  return (
    <form className={className} autoComplete="off">
      <div className={styles.subheader}>Create Password</div>
      <PassInput
        className={styles.phoneInput}
        value={pass}
        onChange={handlePasswordChange}
        isVisible={isPassVisible}
        switchVisibility={() => setIsPassVisisble(!isPassVisible)}
        onBlur={onBlurPass}
        error={showPassError}
        autoComplete="off"
        white
        wide
      />
      <PassInput
        className={clsx(styles.phoneInput, 'top-10')}
        value={pass2}
        onChange={handlePassword2Change}
        isVisible={isPassVisible}
        switchVisibility={() => setIsPassVisisble(!isPassVisible)}
        onBlur={onBlurPass}
        error={showPassError}
        errorMessage={getError()}
        autoComplete="off"
        white
        wide
      />

      <Info white>
        <span>
          Password must be at least {' '}
          <em>8 characters</em> long
        </span>
      </Info>

      <Button
        className={styles.margin20}
        disabled={!isPassValid || isSignupLoading}
        onClick={() => signUpMutation()}
        loading={isSignupLoading}
        purple
        wide
      >
        Next
      </Button>

      <div className={styles.panelFooter}>
        <SignInLink onClick={goToSignIn} />
      </div>
    </form>
  )
}

export default PassView
